var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.698 4.578a1.35 1.35 0 0 1 2.222-.493l6.986 6.973a1.35 1.35 0 0 1-.492 2.224L2.427 17.285c-1.078.392-2.124-.653-1.73-1.731l1.377-3.777a.745.745 0 0 1 .052-.144L3.527 7.79c.015-.071.04-.14.075-.205l1.096-3.007Zm-1.594 8.748-.89 2.44 2.44-.89-1.55-1.55Zm3.106.984L3.67 11.772 4.57 9.31l4.103 4.103-2.462.897Zm6.47-2.357-2.453.894-5.091-5.091.891-2.443 6.653 6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54AFC0",
    d: "M15.394 1.165a.75.75 0 0 1 .75.75c0 .109-.047.71-.366 1.311-.346.652-1.035 1.33-2.243 1.33-.528 0-.768.248-.918.53-.139.26-.178.529-.188.6-.003.02-.004.024-.004.01a.75.75 0 1 1-1.5 0c0-.112.048-.713.367-1.315.347-.652 1.037-1.325 2.243-1.325.527 0 .767-.249.917-.532a1.897 1.897 0 0 0 .192-.61.75.75 0 0 1 .75-.75Z",
    className: "accent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE442C",
    d: "M9.278.224a.75.75 0 0 1 .75.75v2.242a.75.75 0 0 1-1.5 0V.974a.75.75 0 0 1 .75-.75Z",
    className: "accent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5B63F",
    d: "M17.836 5.23a.75.75 0 0 1-.474.95l-2.366.792a.75.75 0 0 1-.474-1.423l2.365-.792a.75.75 0 0 1 .95.474Z",
    className: "accent"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8866D4",
    d: "M14.585 8.806a.75.75 0 0 1 .92-.529l1.927.53a.75.75 0 0 1-.39 1.448l-1.927-.53a.75.75 0 0 1-.53-.919Z",
    className: "accent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.4db597a0da42595b9de80dfe34f80183.svg";
export { ForwardRef as ReactComponent };